/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_CompaniesInputs */

const en_total_companies = /** @type {(inputs: Total_CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Companies`)
};

const de_total_companies = /** @type {(inputs: Total_CompaniesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen insgesamt`)
};

/**
* | output |
* | --- |
* | "Total Companies" |
*
* @param {Total_CompaniesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const total_companies = /** @type {((inputs?: Total_CompaniesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_CompaniesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_total_companies(inputs)
	return en_total_companies(inputs)
});